{
  "ddd, MMM D, YYYY": "ddd, D [de] MMM [de] YYYY",
  "h:mm A z": "HH:mm z",
  "Video fragment {number}": "Fragmento de vídeo {number}",
  "Upload to Beginning": "Enviar para o início",
  "Upload to End": "Enviar para o final",
  "Replace All Video": "Substituir todo o vídeo",
  "Total length: {duration}": "Duração total: {duration}",
  "Upload After": "Enviar depois deste",
  "Delete this uploaded video?": "Excluir este vídeo enviado?",
  "Delete this video fragment?": "Excluir este fragmento de vídeo?",
  "Video fragment deleted": "Fragmento de vídeo excluído",
  "Could not delete video fragment": "Não foi possível excluir o fragmento de vídeo",
  "Loading event video...": "Carregando o vídeo do evento...",
  "Deleting video fragment...": "Excluindo o fragmento de vídeo...",
  "Loading uploaded video fragments...": "Carregando os fragmentos de vídeo enviados...",
  "Could not finish upload": "Não foi possível concluir o envio",
  "Could not queue video conversion": "Não foi possível colocar a conversão do vídeo na fila",
  "Event video is uploaded and will be processed now": "O vídeo do evento foi enviado e será processado agora",
  "Upload an edited or backup recording of the live stream. This will replace the current video on event page.": "Envie uma gravação editada ou de backup da transmissão ao vivo. Ela vai substituir o vídeo atual na página do evento.",
  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically": "Envie um vídeo para a página do evento. O vídeo vai aparecer na página do evento antes do início da transmissão ao vivo. Quando você transmitir ao vivo, a transmissão vai substituir automaticamente o vídeo enviado",
  "Delete Uploaded Video?": "Excluir o vídeo enviado?",
  "Notify all guests when it's uploaded": "Avisar todos os convidados quando o vídeo for enviado",
  "Permission to Access Photo Library Necessary": "É preciso permitir o acesso às fotos",
  "Could not access selected video.": "Não foi possível acessar o vídeo selecionado.",
  "Could not open the video.": "Não foi possível abrir o vídeo.",
  "This video may still be in iCloud. Open Photos, download it to this iPhone, and try again.": "Este vídeo pode ainda estar no iCloud. Abra o app Fotos, baixe o vídeo para este iPhone e tente novamente.",
  "Please try again, or choose another video.": "Tente novamente ou escolha outro vídeo.",
  "Could not open video library.": "Não foi possível abrir a biblioteca de vídeos.",
  "Please check if permissions are given": "Verifique se as permissões foram concedidas",
  "Could not start video upload.": "Não foi possível iniciar o envio do vídeo.",
  "Please try another video or check photo permissions in iOS Settings.": "Tente outro vídeo ou verifique as permissões de fotos nos Ajustes do iOS.",
  "Only mov or mp4 files are accepted": "Só são aceitos arquivos mov ou mp4",
  "Cancel this upload?": "Cancelar este envio?",
  "The part already uploaded will be discarded.": "A parte já enviada será descartada.",
  "Cancel upload": "Cancelar envio",
  "Keep uploading": "Continuar enviando",
  "{loaded} from {total}": "{loaded} de {total}",
  "Uploading...": "Enviando...",
  "Video Uploaded": "Vídeo enviado",
  "Converting Video. This may take a few minutes.": "Convertendo o vídeo. Isso pode levar alguns minutos.",
  "Replace live video": "Substituir o vídeo da transmissão",
  "MOV or MP4 video. 10GB Max.": "Vídeo MOV ou MP4. Máx. 10 GB.",
  "Failed to start upload": "Não foi possível iniciar o envio",
  "Trim the video": "Cortar o vídeo",
  "trim|From": "A partir de",
  "Enter start time in hh:mm:ss format if you want to clip the beginning of the video. For example, if you want to start the video 20 minutes into the live stream, enter \"00:20:00\"": "Se quiser cortar o início do vídeo, digite o tempo de início no formato hh:mm:ss. Por exemplo, para o vídeo começar 20 minutos depois do início da transmissão ao vivo, digite \"00:20:00\"",
  "MOV or MP4 video. Up to 200 GB.": "Vídeo MOV ou MP4. Até 200 GB.",
  "upload status|converted": "convertido",
  "upload status|converting": "em conversão",
  "upload status|waiting to convert": "aguardando conversão",
  "This video was already uploaded for this event (status: {status}).": "Este vídeo já foi enviado para este evento (status: {status}).",
  "{part} of {total} {unit}": "{part} de {total} {unit}",
  "Resuming — {sizes} were already uploaded": "Retomando — {sizes} já tinham sido enviados",
  "Starting over — nothing had finished uploading yet": "Recomeçando — nenhuma parte tinha terminado de ser enviada",
  "under a minute left": "falta menos de um minuto",
  "about {count} min left": {
    "one": "falta cerca de {count} min",
    "other": "faltam cerca de {count} min"
  },
  "about {count} h {minutes} min left": {
    "one": "falta cerca de {count} h {minutes} min",
    "other": "faltam cerca de {count} h {minutes} min"
  },
  "about {count} h left": {
    "one": "falta cerca de {count} h",
    "other": "faltam cerca de {count} h"
  },
  "Pause": "Pausar",
  "Resume": "Retomar",
  "Upload again": "Enviar de novo",
  "upload card|View event page": "Ver página do evento",
  "You can leave this page meanwhile.": "Enquanto isso, você pode sair desta página.",
  "Processing starting soon": "O processamento vai começar em breve",
  "We're finishing other videos first. You can leave this page meanwhile.": "Estamos terminando outros vídeos primeiro. Enquanto isso, você pode sair desta página.",
  "Waiting for processing…": "Aguardando o processamento…",
  "Preparing your video…": "Preparando seu vídeo…",
  "Publishing to your event page…": "Publicando na página do seu evento…",
  "Almost done.": "Quase pronto.",
  "Still processing…": "Ainda processando…",
  "Processing video… {percent}%": "Processando o vídeo… {percent}%",
  "Uploading video": "Enviando o vídeo",
  "Waiting for network…": "Aguardando conexão…",
  "Starting the upload…": "Iniciando o envio…",
  "Calculating time left…": "Calculando o tempo restante…",
  "Paused": "Pausado",
  "The upload continues where it stopped.": "O envio continua de onde parou.",
  "Finishing upload…": "Concluindo o envio…",
  "Putting the video together.": "Montando o vídeo.",
  "{size} uploaded": "{size} enviados",
  "Your video is ready": "Seu vídeo está pronto",
  "It's on your event page now.": "Ele já está na página do seu evento.",
  "Upload interrupted": "Envio interrompido",
  "Already uploaded": "Já enviado",
  "Upload cancelled": "Envio cancelado",
  "This upload was cancelled. The event's video hasn't changed.": "Este envio foi cancelado. O vídeo do evento não mudou.",
  "Could not open the video. Please try again.": "Não foi possível abrir o vídeo. Tente novamente.",
  "Discard this unfinished upload?": "Descartar este envio não concluído?",
  "The part already uploaded will be deleted.": "A parte já enviada será excluída.",
  "Discard upload": "Descartar envio",
  "upload|Keep it": "Manter",
  "It replaces the event's video.": "Ele substitui o vídeo do evento.",
  "It goes at the end of the event's video.": "Ele fica no final do vídeo do evento.",
  "It goes at the beginning of the event's video.": "Ele fica no início do vídeo do evento.",
  "It goes between the event's video fragments.": "Ele fica entre os fragmentos do vídeo do evento.",
  "Try again, or upload it again.": "Tente novamente ou envie o vídeo de novo.",
  "Please upload it again.": "Envie o vídeo de novo.",
  "We couldn't process your video": "Não conseguimos processar seu vídeo",
  "“{filename}” was uploaded but couldn't be converted.": "“{filename}” foi enviado, mas não pôde ser convertido.",
  "The video was uploaded but couldn't be converted.": "O vídeo foi enviado, mas não pôde ser convertido.",
  "If it keeps happening, contact support.": "Se isso continuar acontecendo, fale com o suporte.",
  "Trying again…": "Tentando novamente…",
  "Try again →": "Tentar novamente →",
  "Contact support →": "Falar com o suporte →",
  "notice|Dismiss": "Fechar",
  "Unfinished upload": "Envio não concluído",
  "“{filename}” ({size}), {percent}% uploaded.": "“{filename}” ({size}), {percent}% enviado.",
  "Choose the same file to continue where the upload stopped.": "Escolha o mesmo arquivo para continuar de onde o envio parou.",
  "Resume upload →": "Retomar envio →",
  "Discard": "Descartar",
  "Photo Library": "Fototeca",
  "Files": "Arquivos",
  "Choose a video": "Escolha um vídeo",
  "Your event is live. Upload after the stream ends.": "Seu evento está ao vivo. Envie o vídeo depois que a transmissão terminar.",
  "This event no longer exists.": "Este evento não existe mais.",
  "You don't have access to upload video to this event.": "Você não tem permissão para enviar vídeos para este evento.",
  "This upload has expired. Please choose the file again.": "Este envio expirou. Escolha o arquivo novamente.",
  "This upload has already finished or was cancelled.": "Este envio já foi concluído ou cancelado.",
  "Some parts of the video haven't uploaded yet.": "Algumas partes do vídeo ainda não foram enviadas.",
  "The uploaded video doesn't match the file. Please upload it again.": "O vídeo enviado não corresponde ao arquivo. Envie-o novamente.",
  "This video was already uploaded for this event.": "Este vídeo já foi enviado para este evento.",
  "Too many uploads are in progress. Finish or cancel one, then try again.": "Há envios demais em andamento. Conclua ou cancele um deles e tente novamente.",
  "This file is too large. Videos can be up to 200 GB.": "Este arquivo é grande demais. Os vídeos podem ter até 200 GB.",
  "This file is empty. Please choose another video.": "Este arquivo está vazio. Escolha outro vídeo.",
  "Please choose a video file (MP4 or MOV).": "Escolha um arquivo de vídeo (MP4 ou MOV).",
  "This upload couldn't be started. Please choose the file again.": "Não foi possível iniciar este envio. Escolha o arquivo novamente.",
  "Video upload is temporarily unavailable. Please try again later.": "O envio de vídeos está temporariamente indisponível. Tente novamente mais tarde.",
  "Something went wrong on our side. Please try again.": "Algo deu errado do nosso lado. Tente novamente.",
  "This video can't be converted again. Please upload it again.": "Este vídeo não pode ser convertido de novo. Envie-o novamente.",
  "This upload is no longer available. Please choose the file again.": "Este envio não está mais disponível. Escolha o arquivo novamente.",
  "This upload can't continue. Please choose the file again.": "Este envio não pode continuar. Escolha o arquivo novamente.",
  "This file can't be uploaded. Please choose another video.": "Este arquivo não pode ser enviado. Escolha outro vídeo.",
  "Too many uploads at once. Please wait a moment and try again.": "Muitos envios ao mesmo tempo. Aguarde um momento e tente novamente.",
  "Could not reach the upload service. Check your internet connection and try again.": "Não foi possível conectar ao serviço de envio. Verifique sua conexão com a internet e tente novamente.",
  "The upload was interrupted. Check your internet connection and try again.": "O envio foi interrompido. Verifique sua conexão com a internet e tente novamente.",
  "This upload doesn't match the file. Please choose the file again.": "Este envio não corresponde ao arquivo. Escolha o arquivo novamente.",
  "Could not finish the upload. Please try again.": "Não foi possível concluir o envio. Tente novamente.",
  "Could not read the video file. Please choose it again.": "Não foi possível ler o arquivo de vídeo. Escolha-o novamente.",
  "Another upload for this event is still in progress.": "Outro envio para este evento ainda está em andamento.",
  "There's no upload to continue.": "Não há nenhum envio para continuar.",
  "Could not start the conversion again. Please try again later.": "Não foi possível reiniciar a conversão. Tente novamente mais tarde.",
  "Choose the file again to continue the upload.": "Escolha o arquivo novamente para continuar o envio.",
  "That's a different file. Choose “{name}” to continue this upload.": "Esse é outro arquivo. Escolha “{name}” para continuar este envio.",
  "Choose a video file.": "Escolha um arquivo de vídeo.",
  "There isn't enough free space on this device to continue the upload. Free up some space, then try again.": "Não há espaço livre suficiente neste dispositivo para continuar o envio. Libere espaço e tente novamente.",
  "This upload was cancelled.": "Este envio foi cancelado.",
  "Upload failed": "Falha no envio",
  "Upload File": "Enviar arquivo",
  "File uploaded": "Arquivo enviado",
  "Guest list saved to Files": "Lista de convidados salva em Arquivos",
  "Downloads > {filename}": "Downloads > {filename}",
  "Files > On my iPhone > EventLive > {filename}": "Arquivos > No Meu iPhone > EventLive > {filename}",
  "Could not save the file.": "Não foi possível salvar o arquivo.",
  "Please try again on web": "Tente novamente pela web"
}
